/// CONFIG ///

const CONFIG = {
    APP_TITLE:      'EcoSupplier',
    API_IP: 		'',
    API_DOMAIN: 	'https://api.ecomarket.ru/',
    API_C_DOMAIN: 	'https://api.ecomarket.ru/',
    API_GATE: 		'https://adm.rm-da-funk.ru/suppliermanager/',
    COOKIE_TITLE: 	'megadmin_sm'
};

export default CONFIG;